import {
  Box,
  Typography,
  Paper,
  Divider,
  Select,
  Button,
  MenuItem,
  Menu,
  Grid,
  CircularProgress,
  TextareaAutosize,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import ImageZoomModal from "./ImageZoomModal";
import { styled } from "@mui/material/styles";
import ArrowDown from "../../../assets/icons/ArrowDown.svg";
import Switch from "@mui/material/Switch";
import React, { useState, useEffect } from "react";
import BackArrow from "../../../assets/icons/BackArrow.svg";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import GreyDownArrow from "../../../assets/icons/GreyDownArrow.svg";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import ReactAudioPlayer from "react-audio-player";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getDefectsDetailsList,
  updateDefectsDetailsList,
} from "../../../redux/actions/defectsAction";
import { setLoaderSaveButton } from "../../../redux/actions/userActions";
import jsPDF from "jspdf";
import GenerateDefectId from "../../../utils/GenerateDefectId";
import html2canvas from "html2canvas";
import attach from "../../../assets/images/attach.png";
import ImageComponent from "./ImageComponent";
import { type } from "@testing-library/user-event/dist/type";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const EditDefectDetailsContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const { DefectsRowData } = location?.state || {};

  const defectstDetailsData = useSelector(
    (state) => state?.defects?.defectstDetailsData
  );

  const staticDefectsRowData = {
    display_id: 12345,
    updatedAt: "2023-11-07T12:34:56",
    // defect_report_status: 'true',
    category_defetct: "Sample Category",
  };

  const staticDefectstDetailsData = {
    description: "Sample description",
    cause: "Sample cause",
    immediate_correction_qa_one: "Sample answer 1",
    immediate_correction_qa_two: "Sample answer 2",
    immediate_correction_qa_three: "Sample answer 3",
    defect: {
      audio_file: "sample_audio.mp3",
      file: ["image1.jpg", "image2.jpg"],
    },
  };

  const [defectsRowData, setDefectsRowData] = useState({});
  const [defectsDetailsData, setDefectsDetailsData] = useState({});

  const [showPreview, setShowPreview] = useState(
    false
    //   () => {
    //   const storedValue = localStorage.getItem('showPreview');
    //   return storedValue ? JSON.parse(storedValue) : false;
    // }
  );

  useEffect(() => {
    localStorage.setItem("showPreview", JSON.stringify(showPreview));
  }, [showPreview]);

  const funcOnCLick = (x, y) => {
    setDefectsRowData(x);
    setDefectsDetailsData(y);
    localStorage.setItem("showPreview", "true");
    if (typeof window !== undefined) {
      window.location.reload();
    }
  };

  const BackDefects = () => {
    setShowPreview(false);
  };

  const currentYear = new Date().getFullYear();
  const isLoading = useSelector((state) => state?.user?.isLoading);

  const isSaveButtonLoading = useSelector(
    (state) => state?.user?.isSaveButtonLoading
  );
  const isUpdateSuccessDefectstDetails = useSelector(
    (state) => state?.defects?.isUpdateSuccessDefectstDetails
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [Status, setStatus] = useState(DefectsRowData?.defect_report_status);

  const [selectedIMG, setselectedIMG] = useState([]);

  const [Comment, setComment] = useState(
    DefectsRowData?.line_manager_comment === null
      ? ""
      : DefectsRowData?.line_manager_comment
  );

  const [CorrectiveAction, setCorrectiveAction] = useState(
    DefectsRowData?.corrective_actions === null
      ? ""
      : DefectsRowData?.corrective_actions
  );

  const [FollowupInspection, setFollowupInspection] = useState(
    DefectsRowData?.followup_inspection === null
      ? ""
      : DefectsRowData?.followup_inspection
  );

  const [DefectDetailsData, setDefectDetailsDataData] = useState({
    Description: "",
    Cause: "",
    ImmediateCorrection_1: "",
    ImmediateCorrection_2: "",
    ImmediateCorrection_3: "",
  });

  const handleDefectDetailsData = (e) => {
    const { name, value } = e.target;
    setDefectDetailsDataData({ ...DefectDetailsData, [name]: value });
  };

  const handleChangeComment = (event) => {
    setComment(event.target.value);
  };

  const handleChangeCorrectiveAction = (event) => {
    setCorrectiveAction(event.target.value);
  };

  const handleChangeFollowupInspection = (event) => {
    setFollowupInspection(event.target.value);
  };

  useEffect(() => {
    setSelectedImages(
      defectstDetailsData?.line_manager_attachment === null
        ? []
        : defectstDetailsData?.line_manager_attachment
    );

    setDefectDetailsDataData({
      Description:
        defectstDetailsData?.description === null
          ? ""
          : defectstDetailsData?.description,
      Cause:
        defectstDetailsData?.cause === null ? "" : defectstDetailsData?.cause,
      ImmediateCorrection_1:
        defectstDetailsData?.immediate_correction_qa_one === null
          ? ""
          : defectstDetailsData?.immediate_correction_qa_one,
      ImmediateCorrection_2:
        defectstDetailsData?.immediate_correction_qa_two === null
          ? ""
          : defectstDetailsData?.immediate_correction_qa_two,
      ImmediateCorrection_3:
        defectstDetailsData?.immediate_correction_qa_three === null
          ? ""
          : defectstDetailsData?.immediate_correction_qa_three,
    });
  }, [defectstDetailsData]);

  const openModal = (image) => {
    if (image) {
      setSelectedImage(image);
      setIsModalOpen(true);
    }
  };

  const handleImageSelection = (event) => {
    const files = event.target.files;

    const resultArray = Object.values(files);
    console.log("fdwejgh", event.target.files, resultArray);

    setselectedIMG([...selectedIMG, ...event.target.files]);

    if (files.length === 0) return;
    // resultArray.forEach((item) => {
    //   const newImages = URL.createObjectURL(item);
    //   setSelectedImages((prevImages) => [
    //     ...prevImages,
    //     {
    //       url: newImages,
    //     },
    //   ]);
    // });

    resultArray.forEach((item) => {
      const newFile = {
        URL: URL.createObjectURL(item),
        contentType: item.type,
      };

      setSelectedImages((prevImages) => [...prevImages, newFile]);
    });
  };

  const closeModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
  };

  const handleDeleteImage = (index) => {
    setSelectedImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setselectedIMG((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const handleSaveDefectDetails = async (event) => {
    event.preventDefault();
    const AllReadyExiesIMG = selectedImages
      ?.map((item) => item.Key)
      .filter((Key) => Key !== undefined);
    if (Comment !== "") {
      dispatch(
        updateDefectsDetailsList({
          defect_report_status: Status,
          id: DefectsRowData?.id,
          selectedIMG: selectedIMG,
          AllReadyExiesIMG: AllReadyExiesIMG,
          line_manager_comment: Comment,
          corrective_actions: CorrectiveAction,
          followup_inspection: FollowupInspection,
          description: DefectDetailsData?.Description,
          cause: DefectDetailsData?.Cause,
          immediate_correction_qa_one: DefectDetailsData?.ImmediateCorrection_1,
          immediate_correction_qa_two: DefectDetailsData?.ImmediateCorrection_2,
          immediate_correction_qa_three:
            DefectDetailsData?.ImmediateCorrection_3,
        })
      );
    } else {
      toast.error(
        "Please enter Fleet Director / Vessel Superintendent Comments"
      );
    }
  };
  console.log("fnehnfiwuefio", selectedImages);
  useEffect(() => {
    if (isUpdateSuccessDefectstDetails) {
      navigate("/defects");
    }
  }, [isUpdateSuccessDefectstDetails]);

  useEffect(() => {
    dispatch(
      getDefectsDetailsList({
        id: DefectsRowData?.id,
      })
    );
    dispatch(setLoaderSaveButton(false));
  }, []);

  const createPDF = async () => {
    const pdf = new jsPDF("portrait", "pt", "a4");
    const data = await document.querySelector("#pdf");
    pdf.html(data).then(() => {
      pdf.save("Defect Details.pdf");
    });
  };

  return (
    <>
      <>
        <Paper
          sx={{
            width: "auto",
            height: "820px",
            overflow: "auto",
            borderRadius: "10px",
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#20724E",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#E5F1EB",
            },
          }}
        >
          <Box
            sx={{
              position: "sticky",
              backgroundColor: "#FFFFFF",
              top: "0",
              zIndex: "100",
            }}
          >
            <Box
              sx={{
                height: "80px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "20px",
                overflow: "auto",
                width: "auto",
                overflowX: "auto",
                "&::-webkit-scrollbar": {
                  width: "5px",
                  height: "2px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#20724E",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#E5F1EB",
                },
                "@media (max-width: 768px)": {
                  width: "100%",
                },
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Box
                  sx={{
                    display: "flex",
                    ml: 2,
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    navigate("/defects");
                  }}
                >
                  <img src={BackArrow} alt="" width="17" height="17" />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      ml: 1,
                      fontSize: "18px",
                      fontWeight: 600,
                      color: "#212121",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Defect Details
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    mr: 2,
                  }}
                >
                  {/* <Button
                      // variant="outlined"
                      sx={{
                        fontSize: "15px",
                        fontWeight: 600,
                        border: "1px solid #E5F1EB",
                        width: "9rem",
                        backgroundColor: "#E5F1EB",
                        padding: "8px 15px 5px 15px",
                        borderRadius: "10px",
                        textTransform: "capitalize",
                        color: "#20724E",
                        ":hover": {
                          backgroundColor: "#E5F1EB",
                          border: "1px solid #E5F1EB",
                        },
                      }}
                      onClick={() =>
                        funcOnCLick(
                          staticDefectsRowData,
                          staticDefectstDetailsData
                        )
                      }
                    >
                      Export as PDF
                    </Button> */}
                  <Button
                    variant="outlined"
                    sx={{
                      fontSize: "15px",
                      fontWeight: 600,
                      border: "1px solid #26875C",
                      width: "6rem",
                      backgroundColor: "FFFFFF",
                      padding: "8px 15px 5px 15px",
                      borderRadius: "10px",
                      textTransform: "capitalize",
                      color: "#26875C",
                      ":hover": {
                        border: "1px solid #26875C",
                      },
                    }}
                    onClick={() => {
                      navigate("/defects");
                    }}
                  >
                    Cancel
                  </Button>

                  <LoadingButton
                    variant="contained"
                    sx={{
                      fontSize: "15px",
                      fontWeight: 600,
                      border: "1px solid #26875C",
                      width: "6rem",
                      backgroundColor: "#26875C",
                      padding: "8px 15px 5px 15px",
                      borderRadius: "10px",
                      textTransform: "capitalize",
                      color: "#FFFFFF",
                      ":hover": {
                        backgroundColor: "#26875C",
                      },
                    }}
                    loading={isSaveButtonLoading}
                    onClick={handleSaveDefectDetails}
                  >
                    Save
                  </LoadingButton>
                </Box>
              </Box>
            </Box>
            <Divider />
          </Box>
          {isLoading ? (
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "auto",
                height: "70%",
              }}
            >
              <CircularProgress color="success" />
            </Box>
          ) : (
            <Box>
              <Box sx={{ padding: "25px 25px 25px 25px" }}>
                <Grid
                  container
                  sx={{
                    bgcolor: "#F3F6F9",
                    marginBottom: "20px",
                    borderRadius: "10px",
                    padding: "25px 25px 25px 25px",
                  }}
                >
                  <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                        flexDirection: "row",
                        "@media (max-width: 768px) ": {
                          flexDirection: "column",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          // backgroundColor: "#FFFFFF",
                          bgcolor: "#F3F6F9",
                          width: "100%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                          }}
                        >
                          Defect ID :
                        </Typography>
                        <Typography
                          sx={{
                            marginLeft: "5px",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          {GenerateDefectId(
                            DefectsRowData?.vessel?.name,
                            DefectsRowData?.display_id
                          )}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          bgcolor: "#F3F6F9",
                          // backgroundColor: "#FFFFFF",
                          width: "100%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                          }}
                        >
                          Date :{" "}
                        </Typography>
                        <Typography
                          sx={{
                            marginLeft: "5px",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          {moment(DefectsRowData?.updatedAt).format(
                            "D MMMM, YYYY | hh:mm A"
                          )}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                        flexDirection: "row",
                        "@media (max-width: 768px) ": {
                          flexDirection: "column",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          // backgroundColor: "#FFFFFF",
                          bgcolor: "#F3F6F9",
                          width: "100%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                          }}
                        >
                          Question :
                        </Typography>
                        <Typography
                          sx={{
                            marginLeft: "5px",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          {defectstDetailsData?.question?.question}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          bgcolor: "#F3F6F9",
                          // backgroundColor: "#FFFFFF",
                          width: "100%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                          }}
                        >
                          Category of Defect:
                        </Typography>
                        <Typography
                          sx={{
                            marginLeft: "5px",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          {DefectsRowData?.category_defetct}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                        flexDirection: "row",
                        "@media (max-width: 768px) ": {
                          flexDirection: "column",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          // backgroundColor: "#FFFFFF",
                          bgcolor: "#F3F6F9",
                          width: "100%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                          }}
                        >
                          Vessel Name :
                        </Typography>
                        <Typography
                          sx={{
                            marginLeft: "5px",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          {defectstDetailsData?.vessel?.name}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    padding: "5px 10px 10px 10px",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: "18px",
                      lineHeight: "21px",
                      color: "#000",
                    }}
                  >
                    Management Input:
                  </Typography>
                </Box>
                <Grid
                  container
                  sx={{
                    bgcolor: "#E5F1EB",
                    marginBottom: "20px",
                    borderRadius: "10px",
                    // display: "flex",
                    // justifyContent: "center",
                    // flexDirection: "row",
                    "@media (max-width: 768px) ": {
                      flexDirection: "column",
                    },
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{ padding: "25px 25px 25px 25px" }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "#FFFFFF",
                        height: "3.5rem",
                        // width: "100%",
                        padding: "15px",
                        borderRadius: "10px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "600",
                          fontSize: "14px",
                          lineHeight: "21px",
                          color: "#20724E",
                        }}
                      >
                        Status:
                      </Typography>
                      <Select
                        value={Status}
                        onChange={handleChangeStatus}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        IconComponent={() => (
                          <Box
                            sx={{
                              marginRight: "10px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={GreyDownArrow}
                              alt="Custom Icon"
                              width="18"
                              height="24"
                            />
                          </Box>
                        )}
                        sx={{
                          width: "100%",
                          height: "1rem",
                          borderRadius: "10px",
                          backgroundColor: "#FFFFFF",
                          border: "none",
                          "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                            border: "0px solid #F3F6F9",
                            borderRadius: "10px",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      >
                        <MenuItem value="open">Open</MenuItem>
                        <MenuItem value="close">Close</MenuItem>
                        {/* <MenuItem value="in_progress">In-progress</MenuItem> */}
                      </Select>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        padding: "15px 10px 0px 10px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "600",
                          fontSize: "14px",
                          lineHeight: "21px",
                          color: "#20724E",
                        }}
                      >
                        4. Fleet Director / Vessel Superintendent comments:
                      </Typography>
                    </Box>
                    <Box sx={{ marginTop: "10px" }}>
                      {/* <TextField
                        id="outlined-basic"
                        variant="outlined"
                        placeholder="Fleet Director / Vessel Superintendent
                        comments..."
                        value={Comment}
                        onChange={handleChangeComment}
                        sx={{
                          width: "100%",
                          borderRadius: "10px",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "10px",
                          border: "none",
                          "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                            border: "0px solid #F3F6F9",
                            borderRadius: "10px",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      /> */}
                      <TextareaAutosize
                        id="outlined-basic"
                        variant="outlined"
                        placeholder="Fleet Director / Vessel Superintendent
                          comments..."
                        style={{
                          marginTop: "8px",
                          backgroundColor: "#fff",
                          width: "100%",
                          borderRadius: "10px",
                          padding: "12px",
                          border: "none", // Remove the border property
                          outline: "none", // Remove the outline on focus
                        }}
                        className="font-regular mb-3"
                        value={Comment}
                        onChange={handleChangeComment}
                        minRows={2}
                        maxRows={4}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        padding: "15px 10px 0px 10px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "600",
                          fontSize: "14px",
                          lineHeight: "21px",
                          color: "#20724E",
                        }}
                      >
                        5. Corrective / Preventive action Required:
                      </Typography>
                    </Box>
                    <Box sx={{ marginTop: "10px" }}>
                      {/* <TextField
                        id="outlined-basic"
                        variant="outlined"
                        placeholder="Corrective / Preventive action Required..."
                        value={CorrectiveAction}
                        onChange={handleChangeCorrectiveAction}
                        sx={{
                          width: "100%",
                          borderRadius: "10px",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "10px",
                          border: "none",
                          "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                            border: "0px solid #F3F6F9",
                            borderRadius: "10px",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      /> */}
                      <TextareaAutosize
                        id="outlined-basic"
                        variant="outlined"
                        placeholder="Corrective / Preventive action Required..."
                        style={{
                          marginTop: "8px",
                          backgroundColor: "#fff",
                          width: "100%",
                          borderRadius: "10px",
                          padding: "12px",
                          border: "none", // Remove the border property
                          outline: "none", // Remove the outline on focus
                        }}
                        className="font-regular mb-3"
                        value={CorrectiveAction}
                        onChange={handleChangeCorrectiveAction}
                        minRows={2}
                        maxRows={4}
                      />
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{ padding: "25px 25px 25px 25px" }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "#FFFFFF",
                        // width: "50%",
                        padding: "26px",
                        borderRadius: "10px",
                        display: "flex",
                        flexDirection: "column",
                        overflowX: "auto",
                        whiteSpace: "nowrap",
                        "&::-webkit-scrollbar": {
                          width: "5px",
                          height: "2px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "#20724E",
                          borderRadius: "4px",
                        },
                        "&::-webkit-scrollbar-track": {
                          backgroundColor: "#E5F1EB",
                        },
                        "@media (max-width: 768px)": {
                          width: "100%",
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "600",
                          fontSize: "14px",
                          lineHeight: "21px",
                          color: "#20724E",
                        }}
                      >
                        Attachment by Line Manager
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "10px",
                          padding: "5px 5px 5px 5px",
                        }}
                      >
                        {selectedImages?.map((imageUrl, index) => (
                          <Box
                            component="div"
                            key={index}
                            sx={{
                              position: "relative",
                              maxWidth: "70px",
                              maxHeight: "70px",
                              overflow: "hidden",
                              borderRadius: "10px",
                            }}
                          >
                            {imageUrl?.contentType !== "application/pdf" ? (
                              <img
                                src={imageUrl?.URL}
                                alt={`Selected Image ${index + 1}`}
                                onClick={() => openModal(imageUrl?.URL)}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <Box
                                sx={{
                                  position: "relative",
                                  // width: "68px",
                                  overflow: "hidden",
                                  borderRadius: "10px",
                                }}
                              >
                                <a
                                  href={imageUrl?.URL}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "70px",
                                    height: "70px",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <PictureAsPdfIcon />
                                </a>
                              </Box>
                            )}
                            <button
                              onClick={() => handleDeleteImage(index)}
                              style={{
                                position: "absolute",
                                top: "0",
                                borderRadius: "50%",
                                fontSize: "10px",
                                right: "0",
                                backgroundColor: "grey",
                                border: "none",
                                padding: "5px",
                                cursor: "pointer",
                                color: "white",
                              }}
                            >
                              X
                            </button>
                          </Box>
                        ))}
                        <input
                          type="file"
                          accept="image/*, application/pdf"
                          multiple
                          style={{ display: "none" }}
                          id="image-input"
                          onChange={handleImageSelection}
                        />
                        <label htmlFor="image-input">
                          <Box
                            sx={{
                              height: 70,
                              width: 70,
                              borderRadius: "10px",
                              maxHeight: { xs: 233, md: 167 },
                              maxWidth: { xs: 350, md: 250 },
                              border: "1px solid #ccc",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "20px",
                              }}
                            >
                              +
                            </Typography>
                          </Box>
                        </label>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        padding: "15px 10px 0px 10px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "600",
                          fontSize: "14px",
                          lineHeight: "21px",
                          color: "#20724E",
                        }}
                      >
                        6. Follow-up and Close-out Inspection:
                      </Typography>
                    </Box>
                    <Box sx={{ marginTop: "10px" }}>
                      {/* <TextField
                        id="outlined-basic"
                        variant="outlined"
                        placeholder="Follow-up and Close-out Inspection..."
                        value={FollowupInspection}
                        onChange={handleChangeFollowupInspection}
                        sx={{
                          width: "100%",
                          borderRadius: "10px",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "10px",
                          border: "none",
                          "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                            border: "0px solid #F3F6F9",
                            borderRadius: "10px",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      /> */}
                      <TextareaAutosize
                        id="outlined-basic"
                        variant="outlined"
                        placeholder="Follow-up and Close-out Inspection..."
                        style={{
                          marginTop: "8px",
                          backgroundColor: "#fff",
                          width: "100%",
                          borderRadius: "10px",
                          padding: "12px",
                          border: "none", // Remove the border property
                          outline: "none", // Remove the outline on focus
                        }}
                        className="font-regular mb-3"
                        value={FollowupInspection}
                        onChange={handleChangeFollowupInspection}
                        minRows={2}
                        maxRows={4}
                      />
                    </Box>
                  </Grid>
                </Grid>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    padding: "5px 10px 10px 10px",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: "14px",
                      lineHeight: "21px",
                      color: "#20724E",
                    }}
                  >
                    1. Description of Defective/Damaged Equipment or Plant:
                  </Typography>
                </Box>
                <Grid
                  container
                  sx={{
                    // bgcolor: "#E5F1EB",
                    bgcolor: "#F3F6F9",
                    marginBottom: "20px",
                    borderRadius: "10px",
                    padding: "10px",
                  }}
                >
                  <TextField
                    fullWidth
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#FFFFFF",
                      fontSize: "30px",
                      margin: "15px",
                      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                        {
                          border: "none",
                        },
                      "& .MuiInputLabel-root": {
                        display: "none",
                      },
                    }}
                    placeholder="Enter Description of Defective/Damaged Equipment or Plant"
                    // size="small"
                    variant="outlined"
                    type="text"
                    name="Description"
                    value={DefectDetailsData?.Description}
                    onChange={handleDefectDetailsData}
                  />
                </Grid>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    padding: "5px 10px 10px 10px",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: "14px",
                      lineHeight: "21px",
                      color: "#20724E",
                    }}
                  >
                    2. Cause:
                  </Typography>
                </Box>

                <Grid
                  container
                  sx={{
                    bgcolor: "#F3F6F9",
                    marginBottom: "20px",
                    borderRadius: "10px",
                    padding: "10px",
                  }}
                >
                  <TextField
                    fullWidth
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#FFFFFF",
                      fontSize: "30px",
                      margin: "15px",
                      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                        {
                          border: "none",
                        },
                      "& .MuiInputLabel-root": {
                        display: "none",
                      },
                    }}
                    placeholder="Enter Cause"
                    variant="outlined"
                    type="text"
                    name="Cause"
                    value={DefectDetailsData?.Cause}
                    onChange={handleDefectDetailsData}
                  />
                </Grid>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    padding: "5px 10px 10px 10px",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: "14px",
                      lineHeight: "21px",
                      color: "#20724E",
                    }}
                  >
                    3. Immediate Correction:
                  </Typography>
                </Box>
                <Grid
                  container
                  sx={{
                    bgcolor: "#F3F6F9",
                    marginBottom: "20px",
                    borderRadius: "10px",
                    padding: "25px 25px 25px 25px",
                  }}
                >
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                    >
                      <Box
                        sx={{
                          bgcolor: "#F3F6F9",
                          width: "100%",
                          padding: "15px",
                          borderRadius: "10px",
                        }}
                      >
                        <Box sx={{ margin: "10px 0" }}>
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              lineHeight: "21px",
                              color: "#20724E",
                            }}
                          >
                            1. What correctional activity to repair the defect
                            has been carried out by the vessel’s staff?
                          </Typography>
                          {/* <Typography
                              sx={{
                                padding: "10px",
                                position: "relative",
                                left: "12px",
                                fontSize: "14px",
                                fontWeight: "400",
                              }}
                            >
                              {defectstDetailsData?.immediate_correction_qa_one}
                            </Typography> */}
                          <TextField
                            fullWidth
                            sx={{
                              borderRadius: "10px",
                              backgroundColor: "#FFFFFF",
                              fontSize: "30px",
                              margin: "10px",
                              "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                                {
                                  border: "none",
                                },
                              "& .MuiInputLabel-root": {
                                display: "none",
                              },
                            }}
                            placeholder="Enter Answer"
                            size="small"
                            variant="outlined"
                            type="text"
                            name="ImmediateCorrection_1"
                            value={DefectDetailsData?.ImmediateCorrection_1}
                            onChange={handleDefectDetailsData}
                          />
                        </Box>
                        <Divider />
                        <Box sx={{ margin: "10px 0" }}>
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              lineHeight: "21px",
                              color: "#20724E",
                            }}
                          >
                            2. What is the scope of assistance required from
                            shore maintenance staff, including spares (if any)?
                          </Typography>
                          {/* <Typography
                              sx={{
                                padding: "10px",
                                position: "relative",
                                left: "12px",
                                fontSize: "14px",
                                fontWeight: "400",
                              }}
                            >
                              {defectstDetailsData?.immediate_correction_qa_two}
                            </Typography> */}
                          <TextField
                            fullWidth
                            sx={{
                              borderRadius: "10px",
                              backgroundColor: "#FFFFFF",
                              fontSize: "30px",
                              margin: "10px",
                              "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                                {
                                  border: "none",
                                },
                              "& .MuiInputLabel-root": {
                                display: "none",
                              },
                            }}
                            placeholder="Enter Answer"
                            size="small"
                            variant="outlined"
                            type="text"
                            name="ImmediateCorrection_2"
                            value={DefectDetailsData?.ImmediateCorrection_2}
                            onChange={handleDefectDetailsData}
                          />
                        </Box>
                        <Divider />
                        <Box sx={{ margin: "10px 0" }}>
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              lineHeight: "21px",
                              color: "#20724E",
                            }}
                          >
                            3.What requisition(s) have been submitted relating
                            to this defect (nos/dates)?
                          </Typography>
                          {/* <Typography
                              sx={{
                                padding: "10px",
                                position: "relative",
                                left: "12px",
                                fontSize: "14px",
                                fontWeight: "400",
                              }}
                            >
                              {defectstDetailsData?.immediate_correction_qa_three}
                            </Typography> */}
                          <TextField
                            fullWidth
                            sx={{
                              borderRadius: "10px",
                              backgroundColor: "#FFFFFF",
                              fontSize: "30px",
                              margin: "10px",
                              "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                                {
                                  border: "none",
                                },
                              "& .MuiInputLabel-root": {
                                display: "none",
                              },
                            }}
                            placeholder="Enter Answer"
                            size="small"
                            variant="outlined"
                            type="text"
                            name="ImmediateCorrection_3"
                            value={DefectDetailsData?.ImmediateCorrection_3}
                            onChange={handleDefectDetailsData}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={{
                    bgcolor: "#F3F6F9",
                    marginBottom: "20px",
                    borderRadius: "10px",
                    padding: "25px 25px 25px 25px",
                  }}
                >
                  <Grid item xs={12} sx={{ marginBottom: "20px" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                        flexDirection: "row",
                        "@media (max-width: 768px) ": {
                          flexDirection: "column",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          // backgroundColor: "#FFFFFF",
                          bgcolor: "#F3F6F9",
                          width: "50%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "column",
                          // alignItems: "center",
                          "@media (max-width: 768px)": {
                            width: "100%",
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                          }}
                        >
                          Voice Message
                        </Typography>
                        {defectstDetailsData?.defect?.audio_file !== null ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "left",
                              alignItem: "left",
                              padding: "10px",
                            }}
                          >
                            <ReactAudioPlayer
                              src={
                                defectstDetailsData?.defect?.audio_file
                                  ? defectstDetailsData?.defect?.audio_file
                                  : "Audio file is not available"
                              } // Replace with your audio file URL
                              controls
                            />
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              color: "#464E5F",
                              fontSize: "14px",
                              padding: "10px 10px 10px 0",
                              opacity: "0.6",
                            }}
                          >
                            Audio is not available
                          </Box>
                        )}
                      </Box>
                      <Box
                        sx={{
                          bgcolor: "#F3F6F9",
                          // backgroundColor: "#FFFFFF",
                          width: "50%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "column",
                          overflowX: "auto",
                          "&::-webkit-scrollbar": {
                            width: "5px",
                            height: "2px",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#20724E",
                            borderRadius: "4px",
                          },
                          "&::-webkit-scrollbar-track": {
                            backgroundColor: "#E5F1EB",
                          },
                          "@media (max-width: 768px)": {
                            width: "100%",
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                          }}
                        >
                          Attachment by Vessel
                        </Typography>
                        {defectstDetailsData?.defect?.file.length !== 0 ? (
                          <Box
                            sx={{
                              display: "flex",
                              gap: "10px",
                              padding: "5px 5px 5px 5px",
                            }}
                          >
                            {defectstDetailsData?.defect?.file?.map(
                              (image, index) =>
                              image?.contentType !== "application/pdf" ? (
                                  <Box
                                    key={index}
                                    component="img"
                                    sx={{
                                      height: 70,
                                      width: 70,
                                      borderRadius: "10px",
                                      maxHeight: { xs: 233, md: 167 },
                                      maxWidth: { xs: 350, md: 250 },
                                    }}
                                    // alt="Attachment is not available"
                                    src={image?.URL}
                                    onClick={() => openModal(image?.URL)}
                                  />
                                ) : (
                                  <Box
                                    key={index}
                                    sx={{
                                      position: "relative",
                                      overflow: "hidden",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <a
                                      href={image?.URL}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "70px",
                                        height: "70px",
                                        borderRadius: "10px",
                                      }}
                                    >
                                      <PictureAsPdfIcon />
                                    </a>
                                  </Box>
                                )
                            )}
                          </Box>
                        ) : (
                          <Typography
                            sx={{
                              color: "#464E5F",
                              fontSize: "14px",
                              padding: "10px 10px 10px 0",
                              opacity: "0.6",
                            }}
                          >
                            Attachment is not available
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          )}
        </Paper>
        <ImageZoomModal
          sx={{
            width: "50%",
            height: "100%",
            objectfit: "contain",
          }}
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          src={selectedImage}
          alt="Attachment is not available"
        />
      </>
    </>
  );
};

export default EditDefectDetailsContent;
